import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
const initState = {
    type: 'seller',
    topParams: {},
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 搜索列表 */
        onChange(payload, { update, state, rootState }) {
            console.log('payload', payload);
            const { address, name, sellerCode, vin, tel, time, sourceType } = payload;
            const { type } = rootState.payTop;
            const provinceCode = address[0] ? address[0] : '';
            const cityCode = address[1] ? address[1] : '';
            const buyerName = name ? name : '';
            const vinCodeOrLicense = vin ? vin : '';
            const buyerPhone = tel ? tel : '';
            const sellerPendingDateStar = time ? (time[0] ? time[0] : '') : '';
            const sellerPendingDateEnd = time ? (time[1] ? time[1] : '') : '';
            const tradeDateStar = time ? (time[0] ? time[0] : '') : '';
            const tradeDateEnd = time ? (time[1] ? time[1] : '') : '';
            let _param;
            switch (type) {
                case 'buyer':
                    _param = {
                        provinceCode,
                        cityCode,
                        buyerName,
                        vinCodeOrLicense,
                        buyerPhone,
                        tradeDateStar,
                        tradeDateEnd,
                        sourceType,
                    };
                    this.SET_TOP_PARAMS(_param);
                    dispatch.payBuyer.SET_PAGE_CURRENT(1);
                    dispatch.payBuyer.load({});
                    break;
                case 'seller':
                    _param = {
                        provinceCode,
                        cityCode,
                        sellerCode,
                        vinCodeOrLicense,
                        sellerPhone: buyerPhone,
                        sellerPendingDateStar,
                        sellerPendingDateEnd,
                        sourceType,
                    };
                    this.SET_TOP_PARAMS(_param);
                    dispatch.paySeller.SET_PAGE_CURRENT(1);
                    dispatch.paySeller.load({});
                    break;
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_TYPE(state, payload) {
            state.type = payload;
        },
        SET_TOP_PARAMS(state, payload) {
            state.topParams = payload;
        },
    },
});
